import { useEvents } from '../hooks/useEvents'
import { formatEventDates } from '../lib/dates'
import { PrintShell, Table, Empty, usePrintOnReady } from '../components/print/printKit'

// EventsReport — a one-page PDF list of all current events (item 15): name,
// type, dates, status, manager, build progress and a short summary, mirroring
// the Events list view. Browser-print route /events-report.

function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n) + '…' : s
}

export function EventsReport() {
  const { data: events } = useEvents()
  const ready = events != null
  usePrintOnReady(ready)

  const list = (events ?? [])
    .filter((e) => e.archivedAt == null)
    .sort((a, b) => a.startDate.localeCompare(b.startDate) || a.name.localeCompare(b.name))

  return (
    <PrintShell>
      <section style={{ paddingBottom: 16 }}>
        <div style={{ fontSize: 12, color: '#5a5a5a', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 6 }}>
          NYMR · Events
        </div>
        <h1>Events programme</h1>
        <p style={{ color: '#5a5a5a' }}>
          {list.length} current event{list.length === 1 ? '' : 's'} · generated {new Date().toLocaleString('en-GB')}
        </p>
      </section>

      {list.length === 0 ? (
        <Empty>No current events.</Empty>
      ) : (
        <Table headers={['Event', 'Type', 'Dates', 'Status', 'Manager', 'Build']}>
          {list.map((e) => (
            <tr key={e.id}>
              <td>
                <strong>{e.name}</strong>
                {e.location && <div style={{ fontSize: 10, color: '#5a5a5a' }}>{e.location}</div>}
                {e.description && <div style={{ fontSize: 10, color: '#5a5a5a', marginTop: 2 }}>{truncate(e.description, 140)}</div>}
              </td>
              <td>{e.type.name}</td>
              <td style={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{formatEventDates(e.dates, e.startDate, e.endDate)}</td>
              <td>{e.status}</td>
              <td>{e.manager?.name ?? '—'}</td>
              <td style={{ textAlign: 'right', fontFamily: 'monospace' }}>{e.progress}%</td>
            </tr>
          ))}
        </Table>
      )}
    </PrintShell>
  )
}
